import { render, staticRenderFns } from "./cardLabor.vue?vue&type=template&id=faedc21c&scoped=true"
import script from "./cardLabor.vue?vue&type=script&lang=js"
export * from "./cardLabor.vue?vue&type=script&lang=js"
import style0 from "./cardLabor.vue?vue&type=style&index=0&id=faedc21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faedc21c",
  null
  
)

export default component.exports